import React from 'react';
import { useTranslation } from 'react-i18next';

import AddIcon from '@mui/icons-material/Add';
import { Button } from '@mui/material';

import { SmsConversationType } from '../types';
import { StartConversationModal } from './StartConversationModal';
import { useOpenStartConversationModal } from './hooks';

interface StartConversationButtonProps {
  onSelectTalent: (conversation: SmsConversationType) => void;
}

const StartConversationButton: React.FC<StartConversationButtonProps> = ({
  onSelectTalent,
}) => {
  const { t } = useTranslation('chat');
  const openStartConversationModal = useOpenStartConversationModal();

  const handleOpen = () => {
    openStartConversationModal();
  };

  return (
    <>
      <Button
        variant="contained"
        color="info"
        startIcon={<AddIcon />}
        onClick={handleOpen}
        fullWidth
        sx={{ mb: 2 }}
      >
        {t('sms.newConversation')}
      </Button>

      <StartConversationModal onSelectTalent={onSelectTalent} />
    </>
  );
};

export default StartConversationButton;
